module.exports = __webpack_public_path__ + "img/logo_transparent.88db3d95.png";